import type { TextareaHTMLAttributes } from 'react';
import { forwardRef } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, error, id, className = '', ...props }, ref) => {
    const inputId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`;
    const errorId = error ? `${inputId}-error` : undefined;

    return (
      <div className="textarea-wrapper">
        {label && (
          <label htmlFor={inputId} className="textarea-label">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={inputId}
          className={`textarea ${error ? 'has-error' : ''} ${className}`}
          aria-invalid={!!error}
          aria-describedby={errorId}
          {...props}
        />
        {error && (
          <p id={errorId} className="textarea-error" role="alert">
            {error}
          </p>
        )}
        {props.maxLength && (
          <p className="textarea-hint">
            {props.value?.toString().length || 0} / {props.maxLength} characters
          </p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
